export default __webpack_public_path__ + "static/media/social-instagram.482d4132.svg";